import * as RwdImages from '@Modules/rwd-images';

import { callViews, trace } from '@ICube/icube-core';

import { default as Header } from '@Views/static.header';
import { Lazyloader } from '@Modules/lazyloader';
import WebFont from 'webfontloader';
import { defaultComparisonConfig } from '@Configs/comparison';
import { defaultLazyHtmlConfig } from '@Configs/lazy-html';
import { defaultNiceScrollConfig } from '@Configs/nicescroll';
import { defaultTabsConfig } from '@Configs/tabs';
import { defaultWishlistConfig } from '@Configs/wishlist';
import { detectIE } from '@Utils/detect-ie';
import { hasTouchEvents as detectTouchEvents } from '@Utils/has-touch-events';
import { getDefaultFancyboxConfig } from '@Configs/fancybox';
import { hasWebpSupport } from '@Utils/has-webp-support';
import { isOverflowing } from '@Utils/is-overflowing';
import { panelRun } from './panel';
import { scrollTo } from '@Utils/scroll-to';

const run = () => {
    const FAKE_SELECTS_SELECTOR = '.js-fake-select';

    const data = ICube.data;

    const $header = document.getElementById('v-header');
    const $ciRodo = $('#ci-rodo');
    const $messageBox = $('#headerMessagesBox');
    const $sendGoogleEvent = $('.js-send-google-event');
    const $tippy = $('[data-tippy-content], [data-tippy-html], .js-has-tippy');
    const $ciMessage = $('.ci-message');
    const $numberFormat = $('.js-number-format');
    const $viewOnce = $('.js-view-once');
    const $toggle = $('.js-toggle');
    const $toggleClass = $('.js-toggle-class');
    const $ciLinkWrapper = $('.js-link-wrapper');
    const $uncheckableRadio = $('.js-uncheckable-radio');
    const $lazyEmails = $('.ci-write, .js-lazy-emails');
    const $forms = $('.js-newsletter-form-box, .js-contact-form, .js-lead-services-form, .js-add-review-form');
    const $formsModalTriggers = $('.js-forms-modal-trigger');
    const $wishlist = $('.js-wishlist');
    const $addToCompare = $('.js-add-to-compare');
    const $tabs = $('.js-tabs');
    const $rwd = document.querySelectorAll('[data-rwd]');
    const $editable = $('.editable, .js-editable');
    const $fakeSelects = $(FAKE_SELECTS_SELECTOR);
    const $ciForm = $('.ci-form');
    const $lazyHtml = $('.js-lazy-html');
    const $renderedEditorsContents = $('.js-ic-ce');
    const hasTouchEvents = detectTouchEvents();
    const isIE = detectIE();
    const defaultFancyboxConfig = getDefaultFancyboxConfig();

    function fontActive() {
        const $breadcrumbs = $('#breadcrumbs');

        if ($breadcrumbs.length) {
            import(ICUBE_RWD_BREADCRUMBS).then(() => {
                $breadcrumbs.icubeRwdBreadcrumbs();

                const $lazyHtml = $breadcrumbs.find('.js-custom-lazy-html');
                if ($lazyHtml.length) {
                    $lazyHtml.icubeLazyHtml({
                        triggerevent: "mouseenter",
                        singlerequest: "true",
                        afterRender: function($el) {
                            import('jquery.nicescroll').then(() => {
                                $el.find('ul').niceScroll(data.get('defaultNiceScrollConfig'));
                                $el.on('mouseenter mouseleave', function() {
                                    $(this).find('ul').getNiceScroll().resize();
                                });
                            });
                        }
                    });
                }
            });
        }
    }

    data.add({
        hasTouchEvents: hasTouchEvents,
        isIE: isIE,
        lazyLoadHtmlIndex: 0,
        defaultLazyHtmlConfig: defaultLazyHtmlConfig(),
        defaultNiceScrollConfig,
        wishlistConfig: defaultWishlistConfig(),
        comparisonConfig: defaultComparisonConfig(),
        tabsConfig: defaultTabsConfig(),
        defaultFancyboxConfig
    });

    $('img').each(function() {
        const $img = $(this);

        if (!$img.hasClass('lazyload') && $img.data('src')) {
            $img.addClass('lazyload');
        }
    });

    Lazyloader.init();

    if (isIE || !ICUBE_CONFIG.fonts) {
        fontActive();
    } else {
        WebFont.load({
            custom: {
                families: ICUBE_CONFIG.fonts
            },
            active: fontActive
        });
    }

    if ($sendGoogleEvent.length) {
        import(ICUBE_SEND_EVENT).then(() => {
            $sendGoogleEvent.each(function() {
                const $self = $(this);

                $self.ciSendEvent({replacements: $self.data('replacements')});
            });
        });
    }

    if (!hasTouchEvents) {
        trace('.js-nicescroll', function(elements) {
            const $elements = $(elements);

            if ($elements.length) {
                import(PLUGINS_PATH + 'nicescroll/jquery.nicescroll').then(() => {
                    $elements.each(function() {
                        const $self = $(this);

                        if ($self.data('nicescroll-shadow')) {
                            $self.closest($self.data('nicescroll-shadow')).addClass('has-shadow');
                        }

                        const niceScrollInstance = $self.niceScroll(data.get('defaultNiceScrollConfig'));

                        const resizeOnHover = $self.data('resize-on-hover');
                        if (resizeOnHover) {
                            const $resizeTrigger = resizeOnHover === 'self' ? $self : $self.closest(resizeOnHover);

                            $resizeTrigger.on('mouseenter mouseleave', function() {
                                niceScrollInstance.resize();
                            });
                        }
                    });
                });
            }
        }, null, true);
    }

    if ($tippy.length) {
        import('@popperjs/core').then(() => {
            import('tippy.js').then((tippy) => {
                $tippy.each(function() {
                    const $self = $(this);

                    if ($self.hasClass('js-has-tippy')) {
                        tippy.delegate(this, {
                            target: '[data-tippy-content], [data-tippy-html]',
                            onShow: function(instance) {
                                const $reference = $(instance.reference);
                                const referenceData = $reference.data();
                                let showTooltip = true;
                                let content = '';

                                /* nie wyświetlamy jeśli ustawiony tryb sprawdzania przepełnienia ("check-overflow") i treść nie wystaje poza kontener */
                                if ($reference.data('tippy-check-overflow') === true && !isOverflowing($reference[0], 'x')) {
                                    return false;
                                }

                                if (referenceData.tippyHtml && referenceData.tippyHtml !== '') {
                                    content = $(referenceData.tippyHtml).get(0).innerHTML;
                                } else {
                                    content = referenceData.tippyContent || '';
                                }

                                if (content !== '') {
                                    instance.setProps({
                                        allowHTML: true,
                                        content: content
                                    });
                                } else {
                                    showTooltip = false;
                                }

                                return showTooltip;
                            }
                        });
                    } else {
                        if (!$self.closest('.js-has-tippy').length) {
                            tippy.default(this, {
                                content: $self.data('tippy-html') ? $($self.data('tippy-html')).get(0) : ''
                            });
                        }
                    }
                });
            });
        });
    }

    if ($ciMessage.length) {
        initCiMessage($ciMessage, $messageBox);
    }

    $(document).on('click', '.js-scroll-to', scrollTo);

    if ($numberFormat.length) {
        import(UTILS_PATH + 'number-format').then(module => {
            $numberFormat.on('input change', function() {
                const $input = $(this);

                $input.val(module.number_format($input.val(), 0, ',', ' '));
            });
        });
    }

    if ($viewOnce.length) {
        import(UTILS_PATH + 'view-once').then(module => {
            $viewOnce.on('click', module.viewOnce);
        });
    }

    if ($toggle.length) {
        import(UTILS_PATH + 'toggle-function').then(module => {
            $toggle.on('click', module.toggleFunction);
        });
    }

    if ($toggleClass.length) {
        import(UTILS_PATH + 'toggle-class').then(module => {
            $toggleClass.on('click', module.toggleClass);
        });
    }

    if ($ciLinkWrapper.length) {
        import(ICUBE_LINK_WRAPPER).then(() => {
            $ciLinkWrapper.ciLinkWrapper({});
        });
    }

    if ($uncheckableRadio.length) {
        import(PLUGINS_PATH + 'uncheckable-radio').then(() => {
            $uncheckableRadio.uncheckableRadio();
        });
    }

    if ($lazyEmails.length) {
        import(ICUBE_LAZY_EMAILS).then(() => {
            IcubeLazyEmails.init($lazyEmails, {
                classes: 'spark js-is-clickable',
                domain: ICUBE_CONFIG.email_domain,
                titleTemplate: __('send_message_to') + ' {{e-mail}}'
            });
        });
    }

    if ($forms.length || $formsModalTriggers.length) {
        import(MODULES_PATH + 'init-forms').then(module => {
            module.initForms($forms, $formsModalTriggers);
        });
    }

    if ($wishlist.length) {
        initCiMessage($ciMessage, $messageBox).then(() => {
            import(MODULES_PATH + 'products-storage').then(ProductsStorage => ProductsStorage.init.call($wishlist, data.get('wishlistConfig')));
        });
    }

    if ($addToCompare.length) {
        initCiMessage($ciMessage, $messageBox).then(() => {
            import(MODULES_PATH + 'products-storage').then(ProductsStorage => ProductsStorage.init.call($addToCompare, data.get('comparisonConfig')));
        });
    }

    if ($tabs.length) {
        import(MODULES_PATH + 'tabs').then(Tabs => Tabs.init.call($tabs, data.get('tabsConfig')));
    }

    if ($rwd.length) {
        import(MODULES_PATH + 'grid').then(Grid => Grid.init.call($rwd));
    }

    /* klasę js-editable wykorzystujemy na elementach, na których chcemy tylko odpalić skrypt (nie jest potrzebny styl) */
    if ($editable.length) {
        import(ICUBE_EDITABLE).then(() => {
            $editable.each(function() {
                const $self = $(this);

                $self.icubeEditable({
                    tables: 'table:not(.js-rwd-disabled)',
                    afterInit: function() {
                        RwdImages.init({
                            context: $self.hasClass('editable') ?  '.editable' : '.js-editable'
                        });
                    }
                });
            });
        });
    }

    if ($fakeSelects.length) {
        import(MODULES_PATH + 'fake-select').then(FakeSelect => FakeSelect.init.call($fakeSelects, FAKE_SELECTS_SELECTOR));
    }

    if ($ciForm.length) {
        import(ICUBE_FORMS).then(() => {
            $ciForm.icubeForm();
        });
    }

    if ($lazyHtml.length) {
        $lazyHtml.icubeLazyHtml(
            $.extend(true, {}, data.get('defaultLazyHtmlConfig'))
        );
    }

    if ($renderedEditorsContents.length) {
        import(MODULES_PATH + 'icube-editor').then(ICubeEditor => ICubeEditor.init.call($renderedEditorsContents));
    }

    if ($ciRodo.length) {
        import(ICUBE_RODO).then(() => {
            $ciRodo.ciRodo();
        });
    }

    if (hasTouchEvents) {
        $('.js-has-clickables, .js-is-clickable').removeClass('js-has-clickables js-is-clickable');
    }

    /* statyczne widoki */
    if ($header) {
        Header.call($header);
    }

    /* dynamiczne widoki */
    callViews();

    /* opóźnione ładowanie zewnętrznych skryptów */
    if (ICUBE_CONFIG.use_delayed_scripts) {
        const $delayedScripts = document.querySelectorAll('fscript');

        ICube.delayedScripts = ICube.delayedScripts || [];

        if ($delayedScripts.length) {
            ICube.delayedScripts.push($delayedScripts);
        }

        if (ICube.delayedScripts.length) {
            import(LIBS_PATH + 'icube/delayed-scripts').then(({ delayedScripts }) => delayedScripts(ICube.delayedScripts));
        }
    }
};

export function mainRun() {
    hasWebpSupport().then((hasWebp) => {
        ICube.data.set('hasWebp', hasWebp);
        run();
        panelRun();
    });
}